import { DEFAULT_BORDER } from 'constants/global';

import Combain from 'assets/icons/combain.svg';
import Wallet from 'assets/icons/wallet.svg';
import Secuer from 'assets/icons/secuer.svg';
import Reward from 'assets/icons/reward.svg';

const sameStyles = {
  boxSize: 'unset',
  w: { mobile: 'full', xm: '340px', laptop: '600px', desktop: '670px' },
  h: { mobile: '340px', laptop: '440px', desktop: '480px' },
  p: { laptop: '0 48px 48px 48px', mobile: '0 24px 24px 24px' },
  borderRadius: { laptop: '48px', mobile: '24px' },
  iconProps: {
    boxSize: { mobile: '40px', laptop: '72px' },
    top: { mobile: '8px', laptop: '12px' },
    left: { mobile: '8px', laptop: '12px' },
    imageProps: { minW: { mobile: '24px', laptop: '32px' } },
  },
};

export const consultingFirstExpertiseCardsSliderData = {
  textTitle: (
    <>
      Зачем бизнесу нужно <br /> ИТ‑консультирование?
    </>
  ),
  cardsData: [
    {
      src: Combain,
      title: 'Аудит',
      text: 'Оценить действующую ИТ\u2011инфраструктуру',
    },
    {
      src: Wallet,
      title: 'Сокращение затрат',
      text: 'Оптимизировать ресурсы на внедрение нового ИТ\u2011решения',
    },
    {
      src: Secuer,
      title: 'Информационная безопасность',
      text: 'Выявить и доработать «узкие» места в работе ИТ\u2011системы компании',
    },
    {
      src: Reward,
      title: 'Повышение эффективности',
      text: 'Усовершенствовать бизнес-процессы компании, сделать их более прозрачными',
    },
  ],
  cardsStyles: [
    { bgColor: 'bg.neonLight', ...sameStyles },
    {
      bgColor: 'bg.white',
      border: DEFAULT_BORDER,
      borderColor: 'line.gray',
      ...sameStyles,
      iconProps: { ...sameStyles.iconProps, bgColor: 'bg.gray' },
    },
    { bgColor: 'bg.gray', ...sameStyles },
    { bgColor: 'bg.grayLight', ...sameStyles },
  ],
};
